/*
 * @Author: your name
 * @Date: 2020-03-14 10:52:35
 * @LastEditTime: 2020-11-20 10:35:44
 * @LastEditors: wutt
 * @Description: In User Settings Edit
 * @FilePath: /DianZiDiTu/src/utility/common/WMTSLayerUtilityJs.js
 */
export class WMTSLayerUtility {
    constructor() {
        this.epsg = "EPSG:4326";

        this.wmtsUrl = null;

        this.serviceName = null;

        this.matrixSetName = null;

        this.formatName = null;

        this.tileSize = [256, 256];

        this.tileGridExtent = null;

        //epsg3857_origin: [-20037508.342787001, 20037508.342787001],
        //epsg4326_origin: [-180, 90],
        this.tileGridOrigin = null;

        this.tileGridResolutions = null;

        this.tileGridMatrixIds = null;

        this.token = null;
        this.params_key_token = null;
    }


    /**
     * 创建wmts图层
     */
    createWmtsLayer() {
        
        let layerSource=this.createWmtsSource();

        let vecLayer = new ol.layer.Tile({
            source: layerSource
        });

        vecLayer.set("ezname", this.serviceName);

        return vecLayer;
    }

    createWmtsLayerEx(olwmtsSource) {
        
        let vecLayer = new ol.layer.Tile({
            source: olwmtsSource
        });

        vecLayer.set("ezname", this.serviceName);

        return vecLayer;
    }

    createWmtsSource()
    {   
        let source=null;

        let srs = ol.proj.get(this.epsg);

        // let newUrl = this.wmtsUrl;
        

        // //创建数据源
        // if (this.token) {
        //     if (!newUrl.endsWith("?")) {
        //         newUrl = newUrl + "?"
        //     }

        //     newUrl = newUrl + "tk=" + this.token;
        // }
        
        let newUrl =this.joinUrl();
        source = new ol.source.WMTS({
            url: newUrl,
            layer: this.serviceName,
            matrixSet: this.matrixSetName,
            format: this.formatName,
            projection: srs,
            tileGrid: new ol.tilegrid.WMTS({
                tileSize: this.tileSize,
                extent: this.tileGridExtent, //范围
                origin: this.tileGridOrigin,
                resolutions: this.tileGridResolutions,
                matrixIds: this.tileGridMatrixIds
            }),
            style: "default",
            wrapX: true
        });
        
        return source;
    }
    /**
     * @Author: wutt
     * @Date: 2020-11-20 10:01:51
     * @Description: 拼接地址
     */
    joinUrl(){
        let newUrl = this.wmtsUrl;
        if(this.token && this.params_key_token){
            if (!newUrl.endsWith("?")) {
                newUrl = newUrl + "?"
            }

            newUrl = newUrl + this.params_key_token +"=" + this.token;
        }
        return newUrl;
    }

}